<template>
<div>
  <div class="d-flex" id="wrapper">
    <!-- Sidebar -->
    <SideBar />
    <!-- /#sidebar-wrapper -->
    <!-- Page Content -->
    <div id="page-content-wrapper">
      <nav style="justify-content:flex-start;" class="navbar navbar-expand-lg navbar-light bg-light border-bottom floating">
        <div>
          <button class="btn btn-outline" id="menu-toggle" @click="sidebar"><span class="navbar-toggler-icon"></span>
          </button>

          <button style="color: rgba(0,0,0,.5);border-color: rgba(0,0,0,.1);" class="btn btn-outline navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
           <span style="padding-top:0.5em;"><i class="fas fa-user-alt"></i><span class="account-div"></span><i class="fas fa-angle-down"></i></span>
          </button>
        </div>
        <div class="d-flex">
          <!-- <i class="fas fa-home text-muted hover-cursor" @click="toPage('/dashboard')"></i> -->
          <p class="text-primary mb-0 hover-cursor">&nbsp;Rental - Product</p>
        </div>
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
          <ul class="navbar-nav ml-auto mt-2 mt-lg-0">
            <li class="nav-item dropdown">
              <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                {{ admin }}
              </a>
              <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdown">
                <a class="dropdown-item link" @click="toPage('/password')"> <i class="fas fa-cog"></i><span class="right-dropdown">Change Password</span></a>
                <a class="dropdown-item link" @click="handleLogout"><i class="fas fa-sign-out-alt"></i><span class="right-dropdown">Logout</span></a>
              </div>
            </li>
          </ul>
        </div>
      </nav>
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12 grid-margin stretch-card card-div">
            <div class="container">
              <h5 class="card-title mb-4"> Rental - Product</h5>
              <div class="search-table container-fluid">
                <div class="row">
                  <div class="col-lg-3 col-sm mobile-div">
                    Product Code/SN
                    <input type="text" name="" class="form-control" placeholder="Product Code/SN" v-model="searchProductCode">
                  </div>
                  <div class="col-lg-4 col-sm mobile-div">
                    Company Name
                    <input type="text" name="" class="form-control" placeholder="Company Name" v-model="searchCompanyName">
                  </div>
                  <div class="col-lg-3 col-sm mobile-div">
                    Product Type
                    <multiselect v-model="searchType" :options="productType" label="productTypeName" :allow-empty="false" :select-label="'Type'" :deselect-label="''" placeholder="Product Type" @input="getOrderProductBrand()"></multiselect>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-3 col-sm mobile-div">
                    Brand
                    <multiselect v-model="searchBrand" :options="brandSelect" :allow-empty="false" :select-label="'Brand'" :deselect-label="''" placeholder="Product Brand" @input="getOrderProductModel()"></multiselect>
                  </div>
                  <div class="col-lg-4 col-sm mobile-div">
                    Model
                    <multiselect v-model="searchModel" :options="modelSelect" :allow-empty="false" :select-label="'Model'" :deselect-label="''" placeholder="Product Model"></multiselect>
                  </div>
                  <div class="col-lg-3 col-sm mobile-div">
                    Product Status
                    <multiselect v-model="searchStatus" :options="statusSelect" label="statusName" track-by="statusName" :allow-empty="false" :select-label="''" :deselect-label="''" placeholder="Product Status"></multiselect>
                  </div>
                </div>
                <div class="row mt-2">
                    <div class="col-sm mobile-div">
                      Start Rent (from)
                      <input
                        type="date"
                        class="form-control w-100"
                        name="deliver_schedule"
                        v-model="startRentFrom"
                      />
                    </div>
                    <div class="col-sm mobile-div">
                      Start Rent (to)
                      <input
                        type="date"
                        class="form-control w-100"
                        name="deliver_schedule"
                        v-model="startRentTo"
                      />
                    </div>
                    <div class="col-sm mobile-div">
                      End Rent (from)
                      <input
                        type="date"
                        class="form-control w-100"
                        name="pickup_schedule"
                        v-model="endRentFrom"
                      />
                    </div>
                    <div class="col-sm mobile-div">
                      End Rent (to)
                      <input
                        type="date"
                        class="form-control w-100"
                        name="pickup_schedule"
                        v-model="endRentTo"
                      />
                    </div>
                    <div class="col-lg-2 col-sm mt-4 mobile-div">
                      <button class="btn btn-primary " @click="searchData"> Search </button>
                    </div>
                  </div>
              </div>
              <!-- <button class="btn btn-sm btn-primary mb-1" @click="toPage('/order/create')"> Create Order </button> -->
              <div style="overflow: scroll;">
                <table class="table table-sm table-bordered table-striped table-responsive-sm" style="padding-top: 20px; width: 1300px;">
                  <thead class="">
                    <tr>
                      <th style="width: 130px">Product Code</th>
                      <th>Type</th>
                      <th>Brand</th>
                      <th>Model</th>
                      <th style="width: 130px">Serial Number</th>
                      <th>Specification</th>
                      <th>Product Status</th>
                      <th>Start Rent</th>
                      <th>End Rent</th>
                      <th>Company Name</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="loadingTable == true">
                      <td colspan="11" class="text-center"><img src="~@/assets/images/load-button.gif"></td>
                    </tr>
                    
                    <tr v-else-if="totalData == 0 && loadingTable == false">
                      <td colspan="11" class="text-center"> Data Not Available</td>
                    </tr>
                    <tr v-for="(data,index) in dataProduct" v-else-if="dataProduct!=null&&dataProduct.length>0" :key="`dataProduct-${index}`">
                      <td>{{ data.productCode }}</td>
                      <td>{{ getProductType(data.productType) }}</td>
                      <td>{{ productBrand[index] }}</td>
                      <td>{{ productModel[index] }}</td>
                      <td>{{ data.serialNumber }}</td>
                      <td v-if="data.bomId">
                        <div v-for="(item,index) in data.bomItem" :key="`itemBom-${index}`">
                          <div v-for="x in item.itemQty" :key="`${item.itemName}Detail-${x}`">
                            {{item.itemName}}
                          </div>
                        </div>
                      </td>
                      <td style="width: 250px;" v-else-if="!data.bomId">{{ productSpec[index] }}</td>
                      <td style="width: 100px;">{{ data.temporary? "Temporary" : "Permanent" }}</td>
                      <td style="width: 100px;">{{ data.startRent }}</td>
                      <td style="width: 100px;">{{ data.endRent }}</td>
                      <td>{{ data.companyName }}</td>

                      <td>
                        <button class="btn btn-primary btn-sm" @click="showDetailRentalModal(index,data.temporary,data.companyId,data.odId,data.bomItem)"> Detail </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div id="wrapperr">
                <div id="c1" style="display: inline-flex;">
                  <div style="margin-right: 10px;">
                    <select class="form-control form-control-sm" v-model="itemPerPage" @change="showPage()">
                      <option :value="10">10</option>
                      <option :value="40">40</option>
                      <option :value="80">80</option>
                    </select>
                  </div>
                  <div class="alignLeft total-data">
                    Total Data {{ totalData }}
                  </div>
                </div>
                <div id="c2">
                  <div class="pagination p8 alignRight">
                    <ul>
                      <a class="is-active link" @click="toDataPage(currentPage-1)" v-if="currentPage != 1">
                        <li>
                       {{'<'}}
                        </li>
                      </a>
                      <a class="page">
                        <li>{{ currentPage }} of {{ totalPage }} page</li>
                      </a>
                      <a class="is-active link" @click="toDataPage(currentPage+1)" v-if="currentPage != totalPage">
                        <li>></li>
                      </a>
                    </ul>
                  </div>
                </div>
              </div>​
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /#page-content-wrapper -->
  </div>

  <!-- start detailrentailproduct -->
  <div class="modal fade" id="modalDetailRentalProduct" role="dialog" v-if="dataProduct!=null&&dataProduct[0]!=null">
    <div class="modal-dialog modal-dialog-centered modal-scroll" style="max-width: 1000px;">
      <!-- Modal content-->
      <div class="modal-content">

        <div class="modal-header">
          <div class="change-title">
            <h4 class="modal-title">{{getProductType(dataProduct[selectedIndex].productType) }} - {{ dataProduct[selectedIndex].productName }} ({{ dataProduct[selectedIndex].condition }})</h4>
            <h6>Product Code : {{ dataProduct[selectedIndex].productCode }}</h6>
            <h6>Serial Number : {{ dataProduct[selectedIndex].serialNumber }}</h6>
          </div>

          <button type="button" class="close" data-dismiss="modal">&times;</button>
        </div>

        <div class="modal-body modal-scroll">

          <table class="table table-sm table-bordered">
            <tr v-if="loadingTableAssign == true">
              <td colspan="5" class="text-center"><img src="~@/assets/images/load-button.gif"></td>
            </tr>
            <!-- <tr>
                                <td colspan="2">Catalogue Specification : {{ productSpec[selectedIndex] }}</td>
                            </tr> -->
            <tr v-if="sProductDetailRenting!=null">
              <td style="width: 50%">
                <b>Actual Specification</b>
                <br>
                <div v-if="dataProduct[selectedIndex].productType > 2">
                  <span v-html="dataProduct[selectedIndex].actual"></span>
                </div>
                <div v-else>
                  <span v-html="dataProduct[selectedIndex].actual" v-if="!dataProduct[selectedIndex].bomItem || (dataProduct[selectedIndex].bomItem && dataProduct[selectedIndex].bomItem.length == 0)"></span>
                  <div v-for="(item,indexes) in dataProduct[selectedIndex].bomItem" :key="indexes" v-else>
                    <div class="container">
                      <div class="row px-0">
                        <div class="px-0">
                          <div class="font-weight-bold">{{item.itemGroup}} : </div>
                        </div>
                        <div>
                          <div v-for="(q,j) in item.itemQty" :key="j" class="ml-1">
                            <div>{{item.itemName}}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </td>
              <td style="width: 50%">
                <b>Catalog Specification</b>
                <br>
                <!-- PRODUCT ID 1 AND 2 -->
                <div v-if="sProductDetailRenting.processor!=null"><b>Processor:</b> {{sProductDetailRenting.processor}}
                  <br>
                </div>
                <div v-if="sProductDetailRenting.ram!=null"><b>RAM:</b> {{sProductDetailRenting.ram}} GB
                  <br>
                </div>
                <div v-if="sProductDetailRenting.storage!=null"><b>Storage:</b> {{sProductDetailRenting.storage}}
                  <br>
                </div>
                <div v-if="sProductDetailRenting.vga!=null"><b>VGA:</b> {{sProductDetailRenting.vga}}
                  <br>
                </div>
                <!-- PRODUCT ID 3 MONITOR-->
                <div v-if="sProductDetailRenting.displaySize!=null"><b>Display Size:</b> {{sProductDetailRenting.displaySize}}
                  <br>
                </div>
                <div v-if="sProductDetailRenting.displayType!=null"><b>Display Type:</b> {{sProductDetailRenting.displayType}}
                  <br>
                </div>
                <div v-if="sProductDetailRenting.portVga!=null"><b>Port Vga:</b> {{sProductDetailRenting.portVga}}
                  <br>
                </div>
                <div v-if="sProductDetailRenting.portDvid!=null"><b>Port Dvid:</b> {{sProductDetailRenting.portDvid}}
                  <br>
                </div>
                <div v-if="sProductDetailRenting.portHdmi!=null"><b>Port Hdmi:</b> {{sProductDetailRenting.portHdmi}}
                  <br>
                </div>
                <!-- PRODUCT ID 4 PRINTER-->
                <div v-if="sProductDetailRenting.feature!=null"><b>Feature:</b> {{sProductDetailRenting.feature}}
                  <br>
                </div>
                <div v-if="sProductDetailRenting.colorTech!=null"><b>Color Tech:</b> {{sProductDetailRenting.colorTech}}
                  <br>
                </div>
              </td>
            </tr>
            <tr v-if="sOrderItemBom!=null && dataProduct[selectedIndex].accessories!=null">
              <td colspan="2">
                <b>Accessories: </b>{{dataProduct[selectedIndex].accessories}}
              </td>
            </tr>
            <tr v-if="sOrderItemBom!=null && ((dataProduct[selectedIndex].productType==1||dataProduct[selectedIndex].productType==2)&&dataProduct[selectedIndex].orderOS!=null&&dataProduct[selectedIndex].orderOS!='')">
              <td colspan="2">
                <b>Operating System: </b>
                {{dataProduct[selectedIndex].orderOS}}
              </td>
            </tr>
            <tr v-if="sOrderItemBom!=null && (dataProduct[selectedIndex].productType==1||dataProduct[selectedIndex].productType==2)">
              <td colspan="2">
                <b>Windows License: </b>
                <span v-if="dataProduct[selectedIndex].orderLicense!=null&&dataProduct[selectedIndex].orderLicense!=''">{{dataProduct[selectedIndex].orderLicense}}</span>
                <span v-else> - </span>
              </td>
            </tr>
            <tr v-if="sOrderItemBom!=null && (dataProduct[selectedIndex].productType==1||dataProduct[selectedIndex].productType==2)">
              <td colspan="2">
                <b>Office License: </b>
                <span v-if="dataProduct[selectedIndex].officeLicense!=null&&dataProduct[selectedIndex].officeLicense!=''">{{dataProduct[selectedIndex].officeLicense}}</span>
                <span v-else> - </span>
              </td>
            </tr>
            <tr v-if="sProductDetailRenting!=null">
              <td colspan="2">
                <!-- PRODUCT ID 1 AND 2 -->
                <div><b>Company Name:</b> {{dataProduct[selectedIndex].companyName}}
                  <br>
                </div>
                <div><b>Order ID:</b> <u class="link-biru" @click="toDetail(dataProduct[selectedIndex].orderId,dataProduct[selectedIndex].groupHash,dataProduct[selectedIndex].companyId)">{{dataProduct[selectedIndex].groupHash}}</u>
                  <br>
                </div>
                <div><b>Start Rent:</b> {{ dataProduct[selectedIndex].startRent }}
                  <br>
                </div>
                <div><b>End Rent:</b> {{ dataProduct[selectedIndex].endRent }}
                  <br>
                </div>

              </td>
            </tr>

          </table>

          <div class="row mr-1">
            <div class="col-md-12 grid-margin stretch-card card-div" style="padding-right: ">

              <div class="d-flex justify-content-between flex-wrap">
                <div class="d-flex align-items-end flex-wrap">
                  <div class="d-flex">
                    <h5 class="card-title">Device History</h5>

                  </div>
                </div>
                <div class="d-flex justify-content-between align-items-end flex-wrap py-1" v-if="!loadingTableTicket&&tickets!=null&&tickets.length>0">
                  <!-- <label class="link-biru" @click="viewAll(dataProduct[selectedIndex].companyName)"> View All </label> -->
                </div>
              </div>
              <div class="card">
                <div class="card-body">
                  <table class="table table-sm table-bordered table-striped table-responsive-sm">
                    <thead>
                      <tr>
                        <th>No Ticket</th>
                        <th>Ticket Date</th>
                        <th>Problem</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-if="loadingTableTicket">
                        <td colspan="4" class="text-center"><img src="~@/assets/images/load-button.gif"></td>
                      </tr>
                      <tr v-else-if="!loadingTableTicket&&tickets!=null&&tickets.length==0">
                        <td colspan="4" class="text-center"> Data Not Available</td>
                      </tr>
                      <tr v-else-if="!loadingTableTicket&&tickets!=null&&tickets.length>0" v-for="(data,index) in tickets" :key="`${data.ticketNo}-${index}`">
                        <td>{{ data.ticketNo }}</td>
                        <td>{{ data.ticketTime }}</td>
                        <td>{{ data.ticketProblem }}</td>
                        <td>
                          <button class="btn btn-primary btn-sm" @click="toTicketDetail(data.ticketId)"> Detail </button>
                        </td>

                      </tr>
                    </tbody>
                    <!-- <tbody v-if="loadingTable == false && historyOrder == ''">
                                            <tr>
                                                <td colspan="4" class="text-center">
                                                    Data not available
                                                </td>
                                            </tr>
                                        </tbody> -->
                  </table>
                </div>
              </div>

              <div style="margin-top : 20px" v-if='buttonUpdateProduct'>
                <div class="d-flex justify-content-between flex-wrap">
                  <div class="d-flex align-items-end flex-wrap">
                    <div class="d-flex">
                      <h5 class="card-title"><b>Unit Sebelumnya</b></h5>

                    </div>
                  </div>
                </div>
                <table class="table table-sm table-responsive-sm">
                  <tr>
                    <td>
                      <!-- <div v-if='dataProduct[selectedIndex].bomId'> -->
                        <div style="margin-bottom : 8px;">
                          <a href="#" @click="toTicketDetail(dataProduct[selectedIndex].ticketId)">{{ dataProduct[selectedIndex].ticketNo }}</a>
                          <br>
                          {{dataProduct[selectedIndex].oldProductName}}
                        </div>
                        <div>
                          <!-- <span v-html="dataProduct[selectedIndex].oldActualDesc" v-if="!dataProduct[selectedIndex].oldBomItem || (dataProduct[selectedIndex].oldBomItem && !dataProduct[selectedIndex].oldBomItem.length)"></span> -->
                        <div v-if="!dataProduct[selectedIndex].oldBomItem || (dataProduct[selectedIndex].oldBomItem && !dataProduct[selectedIndex].oldBomItem.length)">
                          <div v-for="(item,indexes) of Object.keys(selectedOldActualProductDetail)" :key="`old-${indexes}`">
                            <div class="container">
                              <!-- <div class="row px-0" v-if="indexes == 0">
                                <div class="px-0">
                                  <div >{{dataProduct[selectedIndex].oldBom}}</div>
                                </div>
                              </div> -->
                              <div class="row px-0">
                                <div class="px-0">
                                  <div class="font-weight-bold">{{item}} :&nbsp;</div>
                                </div>
                                <div>
                                    <div>{{selectedOldActualProductDetail[item]}} {{item == 'ram' ? 'GB' : ''}}</div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                          
                          <div v-for="(item,indexes) in dataProduct[selectedIndex].oldBomItem" :key="`old-${indexes}`" v-else>
                            <div class="container">
                              <div class="row px-0" v-if="indexes == 0">
                                <div class="px-0">
                                  <div >{{dataProduct[selectedIndex].oldBom}}</div>
                                </div>
                              </div>
                              <div class="row px-0">
                                <div class="px-0">
                                  <div class="font-weight-bold">{{item.itemGroup}} :&nbsp;</div>
                                </div>
                                <div>
                                    <div>{{item.itemName}} ({{item.itemQty}})</div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      <!-- </div> -->
                      <!-- <div v-else>
                        Actual Specification
                      </div> -->
                    </td>
                  </tr>
                </table>
              </div>

            </div>
          </div>

          <div class="row mr-1 justify-content-between" v-if='buttonUpdateProduct'>
          <!-- <div class="row mr-1 justify-content-between" v-if='buttonUpdateProduct'>   -->
            <div class="col-12" v-if="dataProduct[selectedIndex].approvalStatus == 'waiting approval'">
              <div class="float-right">
                <button style="margin-left : 10px;" class="btn btn-danger" v-if='!reopenTicket' @click="showField('createTicket')">
                  Reopen Ticket
                </button>
                <button class="btn btn-primary" v-if='!reopenTicket' @click="showMakePermanentModal('show')" :disabled="loadingButtonApprove">
                  <img src="~@/assets/images/2.gif" style="height: 15px;" v-if="loadingButtonApprove" class="mr-1">Buat Permanen
                </button>
              </div>
            </div>
            <div class="col-12 d-flex align-items-start mt-2" v-if="reopenTicket">
              <div class="d-inline w-100">
                <div class="form-group" :class="{ 'form-group--error': $v.reopenTicketNote.$error }">
                  <textarea class="form__input" rows="3" v-model.trim="$v.reopenTicketNote.$model" placeholder="Internal note tiket. Contoh :Tiket dihandle oleh Susi. Perlu komunikasikan jadwal dengan client" />
                </div>
                <div class="error" v-if="!$v.reopenTicketNote.required">*Required fields</div>
              </div>
            </div>
            
          </div>

          <div class="row mr-1 justify-content-between" v-if='reopenTicket'>
            <div class="col-12">
              <div class="float-right">
                <button style="margin-left : 10px;" class="btn btn-danger" @click="showField('cancelCreate')">Cancel</button>
                <button class="btn btn-primary" @click="submitReopenTicket()" :disabled="loadingButtonReject || !reopenTicketNote"><img src="~@/assets/images/2.gif" style="height: 15px;" v-if="loadingButtonReject" class="mr-1">Submit</button>
              </div>
            </div>
          </div>
        
        </div>
      </div>
    </div>
  </div>
  <!-- end detailrentailproduct -->

  <div class="modal fade" id="modalMakePermanentConfirmation" role="dialog">
    <div class="modal-dialog modal-dialog-centered modal-scroll" style="max-width: 1000px;">
      <!-- Modal content-->
      <div class="modal-content">
        <div class="modal-header">
          <div class="change-title">
            <h4 class="modal-title">Konfirmasi Buat Permanen</h4>
          </div>
        </div>
        <div class="modal-body modal-scroll">
          Apakah anda mau membuat permanen device tersebut ?
          <div class="row mr-1 justify-content-between">
            <div class="col-12">
              <div class="float-right">
                <button class="btn btn-danger">Cancel</button>
                <button class="btn btn-primary" @click="makePermanent()">Save</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <|End Of Content -->
    </div>
  </div>
</div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import SideBar from '../SideBar'
import { required, minLength } from 'vuelidate/lib/validators'
export default {
  name: 'OrderPage',
  components: {
    SideBar,
    Multiselect
  },
  data() {
    return {
      spaceRegex : /[\u00A0\uFEFF\u202F]/g,
      admin: "",
      timer: '',
      permission: [],
      loadingTableAssign: false,
      productBrand: [],
      productBrandSearch: [],
      productSpec: [],
      productModel: [],
      sOrderItemBom: [],
      mOrderActualRenting: [],
      sOrderActualRenting: null,
      mProductDetailRenting: [],
      sProductDetailRenting: null,
      selectedIndex: 0,
      tickets: null,
      loadingTableTicket: false,
      productIdChoose: '',
      productNameChoose: '',
      statusChoose: '',
      searchBrand: 'All',
      searchModel: 'All',
      search: false,
      searchCategory: {
        productCategory: 'All'
      },
      productCategory: [],
      searchType: {
        productType: 'All',
        productTypeName: 'All'
      },
      productType: [],
      brandSelect: [],
      modelSelect: [],
      allShowing: [],
      categoryShowing: [],
      showingChoose: '',
      typeChoose: '',
      searchCompanyName: '',
      searchProductCode: '',
      viewDashboard: false,
      viewOrder: false,
      viewReturn: false,
      viewProduct: false,
      viewPairing: false,
      viewReconcile: false,
      viewResolution: false,
      viewLessor: false,
      viewLessee: false,
      viewEmployee: false,
      editOrder: false,
      editReturn: false,
      editProduct: false,
      editPairing: false,
      editReconcile: false,
      editResolution: false,
      editLessor: false,
      editLessee: false,
      editEmployee: false,
      dataProduct: [],
      totalPage: 0,
      totalData: 0,
      currentPage: 1,
      orderId: "",
      statusOrder: "",
      loadingTable: true,
      searchPic: {
        picId: 'All',
        picName: 'All'
      },
      picSelect: [],
      searchStatus: {
        status: 'All',
        statusName: 'All'
      },
      statusSelect: [{
          status: 'All',
          statusName: 'All'
        },
        {
          status: '0',
          statusName: 'Permanent'
        }, {
          status: '1',
          statusName: 'Temporary'
        }
      ],
      deliveDateFrom: '',
      deliveDateTo: '',
      pickupDateFrom: '',
      pickupDateTo: '',
      urlOrder: '',
      itemPerPage: 10,
      buttonUpdateProduct: false,
      reopenTicket: false,
      inputIdSN: '',
      reopenTicketNote : '',
      dataStock: [],
      companyId: null,
      clientPicSubmit: '',
      clientPicPhoneSubmit: '',
      fieldInputShow: false,
      searchStockClick: false,
      loadingButtonSearch: false,
      odId: null,
      loadingButtonApprove: false,
      loadingButtonReject: false,
      selectedOldActualProductDetail: {},

      // Filter date
      startRentFrom: '',
      startRentTo: '',
      endRentFrom: '',
      endRentTo: '',
    }
  },
  validations: {
    inputIdSN: {
      required
    },
    reopenTicketNote: {
      required
    },
    clientPicSubmit: {
      required
    },
    clientPicPhoneSubmit: {
      required,
      phoneFormat(phoneNumber) {
        return (
          phoneNumber.toString().substring(0, 3) == '628' ||
          phoneNumber.toString().substring(0, 2) == '08' ||
          phoneNumber.toString().substring(0, 2) == '02'
        )
      },
    },
    validationPic: ['clientPicSubmit', 'clientPicPhoneSubmit']
  },
  methods: {
    makePermanent() {
      this.loadingButtonApprove = true
      
      this.$http.post(process.env.APPROVE_TICKET_PRODUCT_RENTING_ADJUSTMENT,{
         ticketId: this.dataProduct[this.selectedIndex].ticketId,
         orderDetailId: this.dataProduct[this.selectedIndex].oldOrderDetailsId, 
         lastOrderDetailId : this.dataProduct[this.selectedIndex].orderDetailsId,
         note: ''
        },{
          headers: {'Asani-Token':localStorage.getItem('jwt')}
        })
        .then(response => {
          if (response.data.status !== 200) {
            swal("Sorry", response.data.message, "error", {
              button: "Ok",
            })
            $('#modalDetailRentalProduct').modal('hide')
            this.getData()
          }else{
            $('#modalDetailRentalProduct').modal('hide')
            swal("Success", response.data.message, "success", {
              button: "Ok",
            }).then(() => {
              window.location.reload()
            })
            this.getData()
          }
          this.loadingButtonApprove = false
      })
      .catch(error => {
        swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            } else {
              window.location.reload()
            }
          })
      })
    },
    submitReopenTicket() {
      this.loadingButtonReject = true 
      setTimeout(() => {this.loadingButtonReject = false}, 5000)

      this.$http.post(process.env.REJECT_TICKET_PRODUCT_RENTING_ADJUSTMENT,{
         ticketId: this.dataProduct[this.selectedIndex].ticketId,
         orderDetailId: this.dataProduct[this.selectedIndex].oldOrderDetailsId, 
         lastOrderDetailId : this.dataProduct[this.selectedIndex].orderDetailsId,
         note: this.reopenTicketNote !== null ? this.reopenTicketNote.replace(this.spaceRegex, ' ') : this.reopenTicketNote
        },{
          headers: {'Asani-Token':localStorage.getItem('jwt')}
        })
        .then(response => {
          if (response.data.status !== 200) {
            swal("Sorry", response.data.message, "error", {
              button: "Ok",
            })
            $('#modalDetailRentalProduct').modal('hide')
            this.getData()
          }else{
            $('#modalDetailRentalProduct').modal('hide')
            swal("Success", response.data.message, "success", {
              button: "Ok",
            }).then(() => {
              window.location.reload()
            })
            this.getData()
          }
          this.loadingButtonReject = false
      })
      .catch(error => {
        swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            } else {
              window.location.reload()
            }
          })
      })
    },
    toTicketDetail(ticketId) {
      const routerData = this.$router.resolve({path:'/resolution/detail/' + ticketId})
      window.open(routerData, '_blank')
    },
    toPhoneFormat(phoneNumber) {
      if (phoneNumber.length == 2 && phoneNumber == '08') {
        this.clientPicPhoneSubmit = '628'
      }
    },
    resetStockSearch() {
      this.searchStockClick = false
    },
    showMakePermanentModal(action) {
      let {loadingButtonApprove} = this
      const {makePermanent} = this
      swal({
        title: "Konfirmasi Buat Permanen",
        text: "Apakah anda mau membuat permanen device tersebut ?",
        icon: "warning",
        buttons: [
          'No, cancel it!',
          'Yes, I am sure!'
        ],
      }).then(function(isConfirm) {
        if (isConfirm) {
          loadingButtonApprove = true
          makePermanent()
        } 
      })
    },
    showField(action) {
      if (action == 'update') {
        this.fieldInputShow = true
        this.dataStock = []
        this.clientPicSubmit = ''
        this.clientPicPhoneSubmit = ''
        this.inputIdSN = ''
        this.searchStockClick = false
      } else if (action == 'cancel') {
        this.fieldInputShow = false
        this.$v.$reset()
      } else if (action == 'createTicket') {
        this.reopenTicket = true
      } else if (action == 'cancelCreate') {
        this.reopenTicket = false
        this.reopenTicketNote = ''
      }
    },
    titleCase: function (str) {
      str = str.toLowerCase().split(' ');
      for (var i = 0; i < str.length; i++) {
        str[i] = str[i].charAt(0).toUpperCase() + str[i].slice(1);
      }
      return str.join(' ');
    },
    jsonParse(json, productType) {
      var html, x, y
      y = JSON.parse(json)
      html = ""
      if (productType == '1' || productType == '2') {
        for (x in y) {
          if (x != 'brand' && x != 'model' && x != 'screen') {
            if (x == 'vga') {
              html += "GPU : " + y[x] + "<br>"
            } else if (x == 'ram') {
              html += this.titleCase(x) + " : " + y[x] + "GB<br>"
            } else {
              html += this.titleCase(x) + " : " + y[x] + "<br>"
            }
          }
        }
      } else if (productType == '3') {
        for (x in y) {
          if (x == 'displaySize') {
            html += "Display Size : " + y[x] + " Inch<br>"
          } else if (x == 'displayType') {
            html += "Display Type : " + y[x]
          }
        }
      } else if (productType == '4') {
        for (x in y) {
          if (x == 'colorTech') {
            html += this.titleCase(x) + " : " + y[x] + "<br>"
          }
        }
      } else if (productType == '5' || productType == '6') {
        for (x in y) {
          if (x == 'processor' || x == 'ram' || x == 'storage') {
            if (x == 'ram') {
              html += this.titleCase(x) + " : " + y[x] + "GB<br>"
            } else {
              html += this.titleCase(x) + " : " + y[x] + "<br>"
            }
          }
        }
      } else {
        for (x in y) {
          if (x == 'specifications') {
            html += y[x]
          }
        }
      }
      return html
    },

    addTag(newTag) {
      const tag = {
        status: newTag,
        statusName: newTag.substring(0, 2) + Math.floor((Math.random() * 10000000))
      }
      this.options.push(tag)
      this.value.push(tag)
    },
    showDetailRentalModal(index, temporary, companyId, orderDetailsId, bomItem) {
      this.loadingTableTicket = true
      this.selectedIndex = index
      this.sOrderItemBom = bomItem
      this.sOrderActualRenting = this.mOrderActualRenting[index]
      this.sProductDetailRenting = this.mProductDetailRenting[index]

      const selectedData = this.dataProduct[index]
      if((!selectedData.oldBomItem || selectedData.oldBomItem && selectedData.oldBomItem.length == 0) && selectedData.oldActualDesc ) {
        this.selectedOldActualProductDetail = JSON.parse(selectedData.oldActualDesc)
      }
      
      
      $('#modalDetailRentalProduct').modal('show')
      this.buttonUpdateProduct = false
      if (temporary == 1) {
        this.buttonUpdateProduct = true
      }
      this.companyId = companyId
      this.odId = orderDetailsId
      this.getDetail()
      this.dataStock = []
      this.clientPicSubmit = ''
      this.clientPicPhoneSubmit = ''
      this.inputIdSN = ''
      this.searchStockClick = false
      this.fieldInputShow = false
      this.$v.$reset()
    },
    showPage() {
      console.log(this.$route.query)
      this.currentPage = this.$route.query.page
      this.searchCompanyName = this.$route.query.companyName
      this.searchBrand = this.$route.query.productBrand
      this.searchModel = this.$route.query.productModel
      this.searchProductCode = this.$route.query.productCode
      this.searchType.productTypeName = this.$route.query.productTypeName
      this.searchType.productType = this.$route.query.productType 
      this.searchStatus.status = this.$route.query.productStatus
      this.searchStatus.statusName = this.$route.query.productStatusName
      this.$router.push({
        path: '/rental/product',
        query: {
          companyName: this.searchCompanyName,
          productBrand: this.searchBrand,
          productModel: this.searchModel,
          productCode: this.searchProductCode,
          productType: this.searchType.productType,
          productTypeName: this.searchType.productTypeName,
          productStatus: this.searchStatus.status,
          productStatusName: this.searchStatus.statusName,
          startRentFrom: this.startRentFrom,
          startRentTo: this.startRentTo,
          endRentFrom: this.endRentFrom,
          endRentTo: this.endRentTo,
          itemPerPage: this.itemPerPage,
          page: 1
        }
      })
    },
    searchData() {
      console.log("masuk sin")
      console.log({
          companyName: this.searchCompanyName,
          productBrand: this.searchBrand,
          productModel: this.searchModel,
          productCode: this.searchProductCode,
          productType: this.searchType.productType,
          productTypeName: this.searchType.productTypeName,
          productStatus: this.searchStatus.status,
          productStatusName: this.searchStatus.statusName,
          startRentFrom: this.startRentFrom,
          startRentTo: this.startRentTo,
          endRentFrom: this.endRentFrom,
          endRentTo: this.endRentTo,
          itemPerPage: this.itemPerPage,
          page: 1
        })
      this.$router.push({
        path: '/rental/product',
        query: {
          companyName: this.searchCompanyName,
          productBrand: this.searchBrand,
          productModel: this.searchModel,
          productCode: this.searchProductCode,
          productType: this.searchType.productType,
          productTypeName: this.searchType.productTypeName,
          productStatus: this.searchStatus.status,
          productStatusName: this.searchStatus.statusName,
          startRentFrom: this.startRentFrom,
          startRentTo: this.startRentTo,
          endRentFrom: this.endRentFrom,
          endRentTo: this.endRentTo,
          itemPerPage: this.itemPerPage,
          page: 1
        }
      })
      // this.getData()
    },
    toDataPage(pagePost) {
      this.loadingTable = true
      this.$router.push({
        path: '/rental/product',
        query: {
          companyName: this.searchCompanyName,
          productBrand: this.searchBrand,
          productModel: this.searchModel,
          productCode: this.searchProductCode,
          productType: this.searchType.productType,
          productTypeName: this.searchType.productTypeName,
          productStatus: this.searchStatus.status,
          productStatusName: this.searchStatus.statusName,
          startRentFrom: this.startRentFrom,
          startRentTo: this.startRentTo,
          endRentFrom: this.endRentFrom,
          endRentTo: this.endRentTo,
          itemPerPage: this.itemPerPage,
          page: pagePost
        }
      })
      this.getData()
    },
    toPage(e) {
      this.$router.push(e)
    },
    async handleLogout() {
      try {
        const response = await this.$http.post(process.env.LOGOUT, {}, {
          headers: {
            'Asani-Token': localStorage.getItem('jwt')
          }
        })
        if (response.data.status !== 200) {
          swal("Sorry", response.data.message, "error", {
            button: "Ok",
          })
          return
        }

      } catch (error) {
        if(error.response.data.status != 401) {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          })
          return
        }
      }
      localStorage.removeItem('jwt')
      localStorage.removeItem('admin_name')
      localStorage.removeItem('roles')
      localStorage.removeItem('user_email')
      localStorage.removeItem('admin_id')
      localStorage.removeItem('changeCatalogPermission')
      this.$router.push('/')
    },
    cekLogin() {
      if (localStorage.getItem('jwt') == null) {
        this.$router.push('/')
      }
    },
    viewAll(x) {
      $('#modalDetailRentalProduct').modal('hide')
      var sc = []
      // this.$router.push('/resolution/search')
      // localStorage.setItem('companyName', x)
      // localStorage.setItem('picName', '')
      // localStorage.setItem('technicianName', '')
      // localStorage.setItem('statusComplain', JSON.stringify(sc))
      this.$router.push({
        path: '/resolution',
        query: {
          companyName: x,
          picName: '',
          technicianName: '',
          statusComplain: JSON.stringify(sc),
          page: 1
        }
      })
    },
    cekPermission() {
      this.permission = localStorage.getItem('roles').replace(/"/g, "").replace("[", "").replace("]", "").split(",")
      for (var i = 0; i < this.permission.length; i++) {
        if (this.permission[i] == "1") {
          this.viewDashboard = true
        }
        if (this.permission[i] == "2.1") {
          this.viewOrder = true
        }
        if (this.permission[i] == "2.2") {
          this.editOrder = true
        }
        if (this.permission[i] == '3.1') {
          this.viewReturn = true
        }
        if (this.permission[i] == '3.2') {
          this.editReturn = true
        }
        if (this.permission[i] == '4.1') {
          this.viewProduct = true
        }
        if (this.permission[i] == '4.2') {
          this.editProduct = true
        }
        if (this.permission[i] == '5.1') {
          this.viewPairing = true
        }
        if (this.permission[i] == '5.2') {
          this.editPairing = true
        }
        if (this.permission[i] == '6') {
          this.viewReconcile = true
        }
        if (this.permission[i] == '7.1') {
          this.viewResolution = true
        }
        if (this.permission[i] == '7.2') {
          this.editResolution = true
        }
        if (this.permission[i] == '8.1') {
          this.viewLessor = true
        }
        if (this.permission[i] == '8.2') {
          this.editLessor = true
        }
        if (this.permission[i] == '9.1') {
          this.viewLessee = true
        }
        if (this.permission[i] == '9.2') {
          this.editLessee = true
        }
        if (this.permission[i] == '10') {
          this.viewEmployee = true
        }
      }
      if (this.viewOrder == false) {
        this.$router.push('/')
      }
    },
    sidebar() {
      $("#wrapper").toggleClass("toggled");
    },
    toDetail(id, orderCode, companyId) {
      $('#modalDetailRentalProduct').modal('hide')
      // localStorage.setItem('orderCode', orderCode)
      // localStorage.setItem('companyIdDetail', companyId)
      // this.$router.push('/order/detail/' + id)
      this.$router.push({
        path: '/order/detail/' + id,
        query: {
          orderCode: orderCode,
          companyIdDetail: companyId
        }
      })
    },
    charCount(str, letter) {
      var letter_Count = 0;
      for (var position = 0; position < str.length; position++) {
        if (str.charAt(position) == letter) {
          letter_Count += 1;
        }
      }
      return letter_Count;
    },
    jsonToArray() {
      var specification = ''
      this.productBrand = []
      this.productModel = []
      this.productSpec = []
      this.mOrderActualRenting = []
      this.mProductDetailRenting = []
      if(this.dataProduct) {
        for (var i = 0; i < this.dataProduct.length; i++) {
          const orderActualDescription = this.dataProduct[i].orderActualDesc ? this.dataProduct[i].orderActualDesc : null
          this.mOrderActualRenting.push(orderActualDescription)
          if(this.dataProduct[i].productDetails) {
            this.mProductDetailRenting.push(JSON.parse(this.dataProduct[i].productDetails))
            this.productBrand.push(JSON.parse(this.dataProduct[i].productDetails).brand)
            this.productModel.push(JSON.parse(this.dataProduct[i].productDetails).model)
              if(this.dataProduct[i]) {
                if(orderActualDescription !== null) {
                  if (this.dataProduct[i].productType == '1' || this.dataProduct[i].productType == '2') {
                    specification = JSON.parse(orderActualDescription).processor + '/' + JSON.parse(orderActualDescription).ram + 'GB/' + JSON.parse(orderActualDescription).storage + '/' + JSON.parse(orderActualDescription).vga         
                    this.productSpec.push(specification)
                  } else if (this.dataProduct[i].productType == '3') {
                    specification = JSON.parse(this.dataProduct[i].productDetails).displaySize + ' Inch'
                    this.productSpec.push(specification)
                  } else if (this.dataProduct[i].productType == '4') {
                    specification = JSON.parse(this.dataProduct[i].productDetails).colorTech
                    this.productSpec.push(specification)
                  } else if (this.dataProduct[i].productType == '5' || this.dataProduct[i].productType == '6') {
                    specification = JSON.parse(orderActualDescription).processor + '/' + JSON.parse(orderActualDescription).ram + 'GB/' + JSON.parse(orderActualDescription).storage
                    this.productSpec.push(specification)
                  }
                } else {
                  this.productSpec.push('')
                }
              }
          }
        }
      }
    },
    getProductType(type) {
      if (type == 1) return 'Laptop'
      if (type == 2) return 'PC Set'
      if (type == 3) return 'Monitor'
      if (type == 4) return 'Printer'
    },
    toTicketDetail(ticketId) {
      window.open(this.$router.resolve('/resolution/detail/' + ticketId).href, '_blank');
    },
    toOrderDetailPage(orderId) {
      $('#modalDetailRentalProduct').modal('hide')
      // this.toDetail()
      // this.$router.push('/order/detail/' + orderId)
    },
    getDetail() {
      this.tickets = []
      var orderDetailsId = this.dataProduct[this.selectedIndex].orderDetailsId
console.log(this.loadingTableTicket)
      this.$http.post(process.env.GET_DETAIL_PRODUCT_RENTING, {
          // serialNumber: "32THKQ1"
          orderDetailsId : Number(orderDetailsId)
        }, {
          headers: {
            'Asani-Token': localStorage.getItem('jwt')
          }
        })
        .then(response => {
          if (response.data.status !== 200) {
            swal("Sorry", response.data.message, "error", {
              button: "Ok",
            })
            // this.handleLogout()
          } else {
            if(response.data.data.length) {
              this.tickets = response.data.data
            }
            this.loadingTableTicket = false
          }
        })
        .catch(error => {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
        })
    },
    getOrderProductType() {
      this.$http.get(process.env.GET_ORDER_PRODUCT_TYPE, {
          headers: {
            'Asani-Token': localStorage.getItem('jwt')
          }
        })
        .then(response => {
          if (response.data.status !== 200) {
            swal("Sorry", response.data.message, "error", {
              button: "Ok",
            })
            // this.handleLogout()
          } else {
            this.productType = []
            this.productType.push({
              productType: 'All',
              productTypeName: 'All',
            })
            for (var i = 0; i < response.data.data.length; i++) {
              this.productType.push({
                productType: response.data.data[i].productType,
                productTypeName: response.data.data[i].productTypeName
              })
            }
            this.productCategory = []
            this.productCategory.push({
              productCategory: 'All'
            })
            this.brandSelect = ['All']
            this.modelSelect = ['All']
            this.getOrderProductBrand()
          }
        })
        .catch(error => {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
        })
    },
    getOrderProductBrand() {
      if(!this.searchBrand) {
        this.searchBrand = 'All'
      }
    
      this.$http.post(process.env.GET_ORDER_PRODUCT_BRAND, {
          productType: this.searchType.productType
        }, {
          headers: {
            'Asani-Token': localStorage.getItem('jwt')
          }
        })
        .then(response => {
          if (response.data.status !== 200) {
            swal("Sorry", response.data.message, "error", {
              button: "Ok",
            })
            // this.handleLogout()
          } else {
            this.brandSelect = ['All']
            for (var i = 0; i < response.data.data.length; i++) {
              this.brandSelect.push(response.data.data[i])
            }
            this.modelSelect = ['All']
            this.getOrderProductModel()
          }
        })
        .catch(error => {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
        })
    },
    getOrderProductModel() {
      if(!this.searchModel) {
          this.searchModel = 'All'
      }
      this.$http.post(process.env.GET_ORDER_PRODUCT_MODEL, {
          productType: this.searchType.productType,
          productBrand: this.searchBrand
        }, {
          headers: {
            'Asani-Token': localStorage.getItem('jwt')
          }
        })
        .then(response => {
          if (response.data.status !== 200) {
            swal("Sorry", response.data.message, "error", {
              button: "Ok",
            })
            // this.handleLogout()
          } else if (response.data.status == 200) {
            this.modelSelect = ['All']
            for (var i = 0; i < response.data.data.length; i++) {
              this.modelSelect.push(response.data.data[i])
            }
          }
        })
        .catch(error => {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
        })
    },
    getData() {
      this.loadingTable = true
      if (localStorage.getItem('productType') != '') {
        this.searchType = {
          productType: localStorage.getItem('productType'),
          productTypeName: localStorage.getItem('productTypeName')
        }
      } else {
        this.searchType = null
      }
      if (localStorage.getItem('productCategory') != '') {
        this.searchCategory = {
          productCategory: localStorage.getItem('productCategory')
        }
      }
      this.currentPage = this.$route.query.page
      this.searchCompanyName = this.$route.query.companyName
      this.searchBrand = this.$route.query.productBrand
      this.searchModel = this.$route.query.productModel
      this.searchProductCode = this.$route.query.productCode
      this.itemPerPage = this.$route.query.itemPerPage
      this.searchType.productTypeName = this.$route.query.productTypeName
      this.searchType.productType = this.$route.query.productType
      this.searchStatus.status = this.$route.query.productStatus
      this.searchStatus.statusName = this.$route.query.productStatusName
      this.startRentFrom = this.$route.query.startRentFrom
      this.startRentTo = this.$route.query.startRentTo
      this.endRentFrom = this.$route.query.endRentFrom
      this.endRentTo = this.$route.query.endRentTo
      let {setErrorFetchData} = this
      this.$http.post(process.env.SEARCH_PRODUCT_RENTING_V2, {
          companyName: this.searchCompanyName !== null ? this.searchCompanyName.replace(this.spaceRegex, ' ') : this.searchCompanyName,
          productType: this.searchType.productType,
          productBrand: this.searchBrand,
          productModel: this.searchModel,
          productCode: this.searchProductCode !== null ? this.searchProductCode.replace(this.spaceRegex, ' ') : this.searchProductCode,
          productStatus: this.searchStatus.status,
          page: Number(this.currentPage),
          itemPerPage: Number(this.itemPerPage),
          startRentFrom: this.startRentFrom,
          startRentTo: this.startRentTo,
          endRentFrom: this.endRentFrom,
          endRentTo: this.endRentTo
        }, {
          timeout: 60 * 10 * 1000,
          headers: {
            'Asani-Token': localStorage.getItem('jwt')
          }
        })
        .then(response => {
          if (response.data.status !== 200) {
            swal("Sorry", response.data.message, "error", {
              button: "Ok",
            })
            // this.handleLogout()
          } else {
            this.dataProduct = response.data.content.data
            // this.productBrand = []
            // this.productModel = []
            // this.productSpec = []
            this.jsonToArray()
   
            this.totalPage = response.data.content.totalPage
            this.currentPage = Number(response.data.content.currentPage)
            this.totalData = response.data.content.totalData
            this.loadingTable = false
          }
        })
        .catch(error => {
          console.log(error.message)
          swal("Sorry",  error.response ? error.response.data.message : error.message , "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
          this.setErrorFetchData()
        }) 
      this.getOrderProductType()
    },
    setErrorFetchData() {
      this.loadingTable = false
      this.totalData = 0
    }
  },
  created() {
    this.cekLogin()
    this.cekPermission()
    this.admin = localStorage.getItem('admin_name')
    this.getData()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.pagination {
  padding: 0px 0;
}
.pagination ul {
  margin: 0;
  padding: 0;
  list-style-type: none;
}
.pagination a {
  display: inline-block;
  padding: 1px 6px;
  color: #222;
}
.p8 a {
  background-color: #2797FB;
  /*margin: auto 5px;*/
  color: #fff;
  /*font-weight: bold;*/
  border: 1px solid #2797FB;
}
.p8 a:hover {
  text-decoration: none;
}
.p8 a.page:hover {
  text-decoration: none;
  color: #fff;
}
.p8 .is-active {
  background-color: #fff;
  color: #2797FB;
}
.alignleft {
  float: left;
}
.alignright {
  float: right;
}
.pagg {
  display: inline-flex;
  overflow: auto;
}
.total-data {
  padding: 11px 0px;
  font-size: 14px;
  color: #343A40;
}
#wrapperr {
  overflow: auto;
  margin: 5px 3px;
}
#c1 {
  float: left;
}
#c2 {
  float: right;
}
.search-table {
  padding-bottom: 7px;
  margin-top: -5px;
  margin-left: -15px;
}
.active {
  color: #2797FB;
}
.right-dropdown {
  margin-left: 7px;
}
.account-div {
  margin: 2px 2px;
}
.right-arrow {
  margin-left: auto;
}
.brand-logo {
  width: 120px;
}
.menu-title {
  margin-left: 1.125rem;
}
.menu-title-order {
  margin-left: 1.95rem;
}
.menu-title-payment {
  margin-left: 1.525rem;
}
ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
  /*width: 200px;*/
  /*background-color: #f1f1f1;*/
}
li.sidebar a {
  display: block;
  color: #000;
  padding: 8px 63px;
  text-decoration: none;
}
li a.active {
  background-color: #4CAF50;
  color: white;
}
li a:hover:not(.active) {
  background-color: #2797FB;
  color: white;
}
.nav-side-menu {
  overflow: auto;
  font-family: verdana;
  font-size: 12px;
  font-weight: 200;
  background-color: #2e353d;
  position: fixed;
  top: 0px;
  width: 300px;
  height: 100%;
  color: #e1ffff;
}
.nav-side-menu .brand {
  background-color: #23282e;
  line-height: 50px;
  display: block;
  text-align: center;
  font-size: 14px;
}
.nav-side-menu .toggle-btn {
  display: none;
}
.nav-side-menu ul,
.nav-side-menu li {
  list-style: none;
  padding: 0px;
  margin: 0px;
  line-height: 35px;
  cursor: pointer;
}
.nav-side-menu ul :not(collapsed) .arrow:before,
.nav-side-menu li :not(collapsed) .arrow:before {
  font-family: FontAwesome;
  content: "\f078";
  display: inline-block;
  padding-left: 10px;
  padding-right: 10px;
  vertical-align: middle;
}
.nav-side-menu ul .active,
.nav-side-menu li .active {
  border-left: 3px solid #d19b3d;
  background-color: #4f5b69;
}
.nav-side-menu ul .sub-menu li.active,
.nav-side-menu li .sub-menu li.active {
  color: #d19b3d;
}
.nav-side-menu ul .sub-menu li.active a,
.nav-side-menu li .sub-menu li.active a {
  color: #d19b3d;
}
.nav-side-menu ul .sub-menu li,
.nav-side-menu li .sub-menu li {
  background-color: #181c20;
  border: none;
  line-height: 28px;
  border-bottom: 1px solid #23282e;
  margin-left: 0px;
}
.nav-side-menu ul .sub-menu li:hover,
.nav-side-menu li .sub-menu li:hover {
  background-color: #020203;
}
.nav-side-menu ul .sub-menu li:before,
.nav-side-menu li .sub-menu li:before {
  font-family: FontAwesome;
  content: "\f105";
  display: inline-block;
  padding-left: 10px;
  padding-right: 10px;
  vertical-align: middle;
}
.nav-side-menu li {
  padding-left: 0px;
  border-left: 3px solid #2e353d;
  border-bottom: 1px solid #23282e;
}
.nav-side-menu li a {
  text-decoration: none;
  color: #e1ffff;
}
.nav-side-menu li a i {
  padding-left: 10px;
  width: 20px;
  padding-right: 20px;
}
.nav-side-menu li:hover {
  border-left: 3px solid #d19b3d;
  background-color: #4f5b69;
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  -o-transition: all 1s ease;
  -ms-transition: all 1s ease;
  transition: all 1s ease;
}
@media (max-width: 767px) {
  .nav-side-menu {
    position: relative;
    width: 100%;
    margin-bottom: 10px;
  }
  .nav-side-menu .toggle-btn {
    display: block;
    cursor: pointer;
    position: absolute;
    right: 10px;
    top: 10px;
    z-index: 10 !important;
    padding: 3px;
    background-color: #ffffff;
    color: #000;
    width: 40px;
    text-align: center;
  }
  .brand {
    text-align: left !important;
    font-size: 22px;
    padding-left: 20px;
    line-height: 50px !important;
  }
}
@media (min-width: 767px) {
  .nav-side-menu .menu-list .menu-content {
    display: block;
  }
}
@media (max-width: 573px) {
  .mobile-div {
    padding: 2px 0px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Order/ProductRentingPage.vue